export default __webpack_public_path__ + "static/media/ceu-observatorio-2.e4dbd1fe.jpeg";